import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CompetitionService } from 'app/services/competition.service';

@Component({
  selector: 'app-competition-header',
  templateUrl: './competition-header.component.html',
  styleUrls: ['./competition-header.component.scss']
})
export class CompetitionHeaderComponent implements OnInit {
  @Output('discard') discard: EventEmitter<void> = new EventEmitter();
  @Output('save') save: EventEmitter<void> = new EventEmitter();

  constructor(private router: Router,
    private route: ActivatedRoute,
    private competitionService: CompetitionService) { }

  ngOnInit() {
  }

  goToAdmin() {
    if (this.competitionService.getCompetitionUrl()) {
      this.router.navigate(['competition', this.competitionService.getCompetitionUrl(),
      'onboarding'],
      { relativeTo: this.route.parent });
    } else {
      this.router.navigate(['admin'],
      {  });
    }
  }

  onDiscard() {
    this.discard.emit();
  }

  onSave() {
    this.save.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/competition-header/competition-header.component.ts